import { render } from "./Socials.vue?vue&type=template&id=3037c7ec&scoped=true"
import script from "./Socials.vue?vue&type=script&lang=js"
export * from "./Socials.vue?vue&type=script&lang=js"

import "./Socials.vue?vue&type=style&index=0&id=3037c7ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3037c7ec"

export default script